import React, { ReactNode } from "react";
import { WorkplaceProvider } from "./contexts/workplace";
import { UserProvider } from "./contexts/user";
import { RoleProvider } from "./contexts/role";
import { GenderProvider } from "./contexts/gender";
import { ClientSourceProvider } from "./contexts/client-source";
import { PermissionsProvider } from "./contexts/permission";
import { UserStatusProvider } from "./contexts/user-status";
import { OfficeProvider } from "./contexts/office";
import { UserTypeProvider } from "./contexts/user-type";
import { SocketProvider } from "../plugins/socket.io";
import { ClientProvider } from "./contexts/client";
import { CountryProvider } from "./contexts/country";
import { RegionProvider } from "./contexts/region";
import { CityProvider } from "./contexts/city";
import { AccountProvider } from "./contexts/account";
import { CurrencyProvider } from "./contexts/currency";
import { AddressProvider } from "./contexts/address";
import { ContactProvider } from "./contexts/contact";
import { ContractProvider } from "./contexts/contract";
import { WorkplaceModuleProvider } from "./contexts/workplace-module";
import { ModuleProvider } from "./contexts/module";
import { WorkplaceRoleProvider } from "./contexts/workplace-role";
import { OfficeAccountProvider } from "./contexts/office-account";
import { ChatProvider } from "./contexts/chat";
import { AssignmentProvider } from "./contexts/assignment";
import { ApplicationFileProvider } from "./contexts/application-file";
import { ClientFileProvider } from "./contexts/client-file";
import { AssignmentFileProvider } from "./contexts/assignment-file";
import { ContractFileProvider } from "./contexts/contract-file";
import { ApplicationProvider } from "./contexts/application";
import { SysSettingsProvider } from "./contexts/sys-setting";
import { ContractTemplateProvider } from "./contexts/contract-template";
import { RequisiteProvider } from "./contexts/requisite";
import { ChatFileProvider } from "./contexts/chat-file";
import { ApplicationStatusProvider } from "./contexts/application-status";
import { BankProvider } from './contexts/bank';
// Импортируйте другие провайдеры по мере необходимости

interface AppProvidersProps {
  children: ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <WorkplaceProvider>
      <UserProvider>
        <SocketProvider>
          <RoleProvider>
            <GenderProvider>
              <ClientSourceProvider>
                <PermissionsProvider>
                  <UserStatusProvider>
                    <OfficeProvider>
                      <UserTypeProvider>
                        <ClientProvider>
                          <CountryProvider>
                            <RegionProvider>
                              <CityProvider>
                                <WorkplaceModuleProvider>
                                  <ContractProvider>
                                    <ModuleProvider>
                                      <WorkplaceRoleProvider>
                                        <AccountProvider>
                                          <CurrencyProvider>
                                            <AddressProvider>
                                              <ContactProvider>
                                                <OfficeAccountProvider>
                                                  <ChatProvider>
                                                    <AssignmentProvider>
                                                      <ApplicationProvider>
                                                        <ApplicationFileProvider>
                                                          <ClientFileProvider>
                                                            <AssignmentFileProvider>
                                                              <ContractFileProvider>
                                                                <SysSettingsProvider>
                                                                  <ContractTemplateProvider>
                                                                    <RequisiteProvider>
                                                                      <ChatFileProvider>
                                                                        <ApplicationStatusProvider>
                                                                          <BankProvider>
                                                                            {children}
                                                                          </BankProvider>
                                                                        </ApplicationStatusProvider>
                                                                      </ChatFileProvider>
                                                                    </RequisiteProvider>
                                                                  </ContractTemplateProvider>
                                                                </SysSettingsProvider>
                                                              </ContractFileProvider>
                                                            </AssignmentFileProvider>
                                                          </ClientFileProvider>
                                                        </ApplicationFileProvider>
                                                      </ApplicationProvider>
                                                    </AssignmentProvider>
                                                  </ChatProvider>
                                                </OfficeAccountProvider>
                                              </ContactProvider>
                                            </AddressProvider>
                                          </CurrencyProvider>
                                        </AccountProvider>
                                      </WorkplaceRoleProvider>
                                    </ModuleProvider>
                                  </ContractProvider>
                                </WorkplaceModuleProvider>
                              </CityProvider>
                            </RegionProvider>
                          </CountryProvider>
                        </ClientProvider>
                      </UserTypeProvider>
                    </OfficeProvider>
                  </UserStatusProvider>
                </PermissionsProvider>
              </ClientSourceProvider>
            </GenderProvider>
          </RoleProvider>
        </SocketProvider>
      </UserProvider>
    </WorkplaceProvider>
  );
};

export default AppProviders;
